import { useEffect, useState } from 'react';

export const DESKTOP_QUERY = '(min-width: 900px)';

/** true se la media query corrisponde; si aggiorna al resize. */
export function useMedia(query: string): boolean {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);
  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches);
    mql.addEventListener('change', onChange);
    setMatches(mql.matches);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);
  return matches;
}

export function useIsDesktop(): boolean {
  return useMedia(DESKTOP_QUERY);
}
